module.exports = __webpack_public_path__ + "static/img/banner_icon_01.14ed226.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner_icon_01.png
// module id = 8fET
// module chunks = 0